import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the ContactProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ContactProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello ContactProvider Provider');
  }
  getMemberInfo(chatroomname, username) {
    let params = {
      chatroomname: chatroomname,
      username: username,
    };
    return this.http.hPost('/memberstatistics/get_memberinfo', params);
  }
  getKeyCloud(chatroom_id, member_id) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
    };
    return this.http.hPost('/member/get_msg_keywords', params);
  }

  // getMsgKeywords(chatroom_id,member_id){
  //   let params = {
  //     chatroom_id:chatroom_id,
  //     member_id:member_id
  //   };
  //   return this.http.hPost('/member/get_msg_keywords',params);
  // }

  getInvitationList(chatroom_id, member_id) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
    };
    return this.http.hPost('/member/get_invitation_list', params);
  }

  getMemberExt(chatroom_id, member_id) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
    };
    return this.http.hPost('/member/get_member_ext', params);
  }

  getColorfulMsg(chatroom_id, member_id) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
    };
    return this.http.hPost('/member/get_colorful_msg', params);
  }

  getMemberMsgTendency(chatroom_id, member_id, scope) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
      scope: scope,
    };
    return this.http.hPost('/member/get_member_msg_tendency', params);
  }

  getAtList(chatroom_id, member_id) {
    let params = {
      member_id: member_id,
      chatroom_id: chatroom_id,
    };
    return this.http.hPost('/member/get_at_list', params);
  }

  getActiveList(chatroom_id, member_id) {
    let params = {
      chatroom_id: chatroom_id,
      member_id: member_id,
    };
    return this.http.hPost('/member/get_active_period', params);
  }


  getInvitedList(chatroomname,username,date_type){
    let params = {
      chatroomname:chatroomname,
      username:username,
      date_type:date_type
    };
    return this.http.hPost('/memberstatistics/invited_list',params)
  }

  getSendAvtivity(chatroomname,username,date_type){
    let params = {
      chatroomname:chatroomname,
      username:username,
      date_type:date_type
    };
    return this.http.hPost('/memberstatistics/send_activity',params);
  }
  getTrendData(chatroomname,username,date_type){
    let params = {
      chatroomname:chatroomname,
      username:username,
      date_type:date_type
    };
    return this.http.hPost('/memberstatistics/dynamic_trend',params);
  }

  getTagList(chatroomname,username,date_type){
    let params = {
      chatroomname:chatroomname,
      username:username,
      date_type:date_type
    };
    return this.http.hPost('/statistics/tag_list',params);
  }
  getActivityData(chatroomname,username,date_type){
    let params = {
      chatroomname:chatroomname,
      username:username,
      date_type:date_type
    };
    return this.http.hPost('/memberstatistics/activity_distr',params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/contact/contact.ts